export const tableSortOrder = (orderData: string, order: string, reverse: string) => {
  if (orderData === order) {
    return reverse === 'Y' ? 'ascend' : 'descend';
  } else {
    return undefined;
  }
};

export const tableSortOrders = (orderDatas: any[], columnKey: string) => {
  const index = orderDatas.findIndex(s => s.columnKey === columnKey);
  if (index > -1) {
    return orderDatas[index].order;
  } else {
    return undefined;
  } 
};
